"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_store_1 = __importDefault(require("../data-store"));
var storable_data_service_1 = __importDefault(require("../storable-data-service"));
var planned_delivery_windows_consts_1 = require("./planned-delivery-windows.consts");
var planned_delivery_windows_service_1 = __importDefault(require("./planned-delivery-windows-service"));
var PlannedDeliveryWindowsApi = /** @class */ (function () {
    function PlannedDeliveryWindowsApi(session) {
        var groupFilters = [
            {
                groupType: planned_delivery_windows_consts_1.PlannedDeliveryWindowsFilterGroups.Team,
                keyFunc: function (deliveryWindow) { return deliveryWindow.team_id; }
            }
        ];
        this.deliveryWindowsStore = new data_store_1.default(groupFilters);
        this.deliveryWindowsService = new planned_delivery_windows_service_1.default(session);
        this.storableDataService = new storable_data_service_1.default(this.deliveryWindowsStore);
    }
    PlannedDeliveryWindowsApi.prototype.load = function (id, options) {
        var _this = this;
        return this.storableDataService.load('load', function () { return _this.deliveryWindowsService.load(id); }, id, options);
    };
    PlannedDeliveryWindowsApi.prototype.loadAllWithoutTeam = function (startTime, endTime, options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAllWithoutTeam', function () { return _this.deliveryWindowsService.loadAllWithoutTeam(startTime, endTime); }, __assign(__assign({}, options), { groupType: planned_delivery_windows_consts_1.PlannedDeliveryWindowsFilterGroups.Team, groupValue: null }));
    };
    PlannedDeliveryWindowsApi.prototype.loadAllByTeam = function (teamId, startTime, endTime, options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAllByTeam', function () { return _this.deliveryWindowsService.loadAllByTeam(teamId, startTime, endTime); }, __assign(__assign({}, options), { groupType: planned_delivery_windows_consts_1.PlannedDeliveryWindowsFilterGroups.Team, groupValue: teamId }));
    };
    PlannedDeliveryWindowsApi.prototype.create = function (plannedDeliveryWindowsData) {
        var _this = this;
        return this.storableDataService.modifyMany('create', function () {
            return _this.deliveryWindowsService.create(plannedDeliveryWindowsData);
        });
    };
    PlannedDeliveryWindowsApi.prototype.delete = function (id, recurrenceOptions) {
        var _this = this;
        return this.storableDataService.delete('delete', function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, this.deliveryWindowsService.delete(id, recurrenceOptions)];
        }); }); }, id);
    };
    PlannedDeliveryWindowsApi.prototype.update = function (id, plannedDeliveryWindow, recurrenceOptions) {
        var _this = this;
        return this.storableDataService.modify('update', function () {
            return _this.deliveryWindowsService.update(id, plannedDeliveryWindow, recurrenceOptions);
        });
    };
    PlannedDeliveryWindowsApi.prototype.get = function (id) {
        return this.deliveryWindowsStore.get(id);
    };
    PlannedDeliveryWindowsApi.prototype.bulkDelete = function (plannedDeliveryWindowsToDelete) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storableDataService.deleteMany('delete', function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.deliveryWindowsService.bulkDelete(plannedDeliveryWindowsToDelete)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, plannedDeliveryWindowsToDelete.planned_delivery_windows.map(function (pdw) { return pdw.planned_delivery_window.id; }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    PlannedDeliveryWindowsApi.prototype.bulkUpdate = function (plannedDeliveryWindowsToEdit) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storableDataService.modifyMany('bulkUpdate', function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.deliveryWindowsService.bulkUpdate(plannedDeliveryWindowsToEdit)];
                                    case 1:
                                        response = _a.sent();
                                        return [2 /*return*/, response.results
                                                .filter(function (res) { return res.success; })
                                                .map(function (res) {
                                                return plannedDeliveryWindowsToEdit.planned_delivery_windows.find(function (pdw) { return pdw.planned_delivery_window.id === res.planned_window_id; }).planned_delivery_window;
                                            })];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    PlannedDeliveryWindowsApi.prototype.getAll = function () {
        return this.deliveryWindowsStore.getAll();
    };
    PlannedDeliveryWindowsApi.prototype.removeAll = function () {
        this.deliveryWindowsStore.removeAll();
    };
    PlannedDeliveryWindowsApi.prototype.getGroup = function (group, groupValue) {
        return this.deliveryWindowsStore.getGroup(group, groupValue);
    };
    return PlannedDeliveryWindowsApi;
}());
exports.default = PlannedDeliveryWindowsApi;
//# sourceMappingURL=planned-delivery-windows-api.js.map